import { Spinner } from '@xanectech/ui/components';

export type LoadingProps = {
  color?: string;
  loading?: boolean;
  spinner?: string;
  random?: boolean;
};
const Loading: React.FC<LoadingProps> = ({
  color = 'rgba(158, 55, 55, 1)',
  loading = true,
  spinner = 'Xanec',
  random = false,
}) => {
  return (
    <Spinner
      color={color}
      loading={loading}
      spinner={spinner}
      random={random}
    />
  );
};

export { Loading };
